import config from 'config';
import axios from 'axios';
import UserFlagsService from './user_flags_service';

const ROOT = config.API_BASE_URL;

class AlertsService {

  static alertsByArea(groupingId, filter=false) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}alerts/alertsByArea?underGroupingId=${groupingId}&filterReturnedAreas=${filter}`).then((data) => {
        resolve({ alertsByArea: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static alertsByGrouping(groupingId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}alerts/alertsByGrouping?underGroupingId=${groupingId}`).then((data) => {
        resolve({ alertsByGrouping: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAll(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}alerts${params}${UserFlagsService.getUserFlagsAsURLParams(options.length > 0)}`).then((data) => {
        resolve({ alerts: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(alertId, withEntity=false) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}alerts/${alertId}?withEntity=${withEntity}${UserFlagsService.getUserFlagsAsURLParams(true)}`).then((data) => {
        resolve({ alert: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static updateStatus(alertId, newStatus) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}alerts/${alertId}/status`, newStatus).then((data) => {
        resolve({ alert: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static addResponse(alertId, responseValue) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}alerts/${alertId}/responses`, responseValue).then((data) => {
        resolve({ alertResponse: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static bulkUpdateStatus(updateStatusHash) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}alerts/bulkUpdateStatus`, updateStatusHash).then((data) => {
        resolve({ response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static updateNote(alertId, newNote) {
    let note = ({alertNote: newNote})
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}alerts/${alertId}/note`, note).then((data) => {
        resolve({ alert: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getEventNotesReport(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}reports/event-notes-report${params}${UserFlagsService.getUserFlagsAsURLParams(options.length > 0)}`).then((response) => {
        resolve({ events: response.data.content, page: response.data, response: response });
      }).catch((err) => {
        reject(err);
      })
    })
  }
}

export default AlertsService;
